import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import classnames from 'classnames'

import Map from '../components/Map/Map'
import MapMarker from '../components/Map/MapMarker'

import styles from '../styles/sections/OccupationArea.module.css'

const OccupationArea = props => {
  const sectionClassName = classnames('section', styles.section)
  const containerClassName = classnames('container', styles.container)

  const renderMarkers = () =>
    props.markdownRemark.frontmatter.markers.map((marker, index) => (
      <MapMarker key={index} {...marker} />
    ))

  return (
    <section id={props.markdownRemark.frontmatter.id} className={sectionClassName}>
      <div className={containerClassName}>
        <div className={styles.map}>
          <Map>{renderMarkers()}</Map>
        </div>

        <div className={styles.textWrapper}>
          <h2 className={styles.title}>
            {props.markdownRemark.frontmatter.title}
            <small className={styles.subtitle}>{props.markdownRemark.frontmatter.subtitle}</small>
          </h2>

          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: props.markdownRemark.html }}
          />
        </div>
      </div>
    </section>
  )
}

OccupationArea.propTypes = {
  markdownRemark: PropTypes.shape({
    frontmatter: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      markers: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          lat: PropTypes.number,
          lng: PropTypes.number
        })
      )
    }),
    html: PropTypes.string
  })
}

const occupationAreaQuery = graphql`
  query OccupationAreaQuery {
    markdownRemark(frontmatter: { id: { eq: "occupationArea" } }) {
      frontmatter {
        id
        title
        subtitle
        markers {
          label
          lat
          lng
        }
      }
      html
    }
  }
`

export default () => (
  <StaticQuery query={occupationAreaQuery} render={data => <OccupationArea {...data} />} />
)
